import { render, staticRenderFns } from "./LandownerTypeForm.vue?vue&type=template&id=245e0d7f&"
import script from "./LandownerTypeForm.vue?vue&type=script&lang=js&"
export * from "./LandownerTypeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports